'use client'

import React, { useEffect } from 'react'
import tippy from 'tippy.js'

export default function Option2({ ProductID, Data = [], onChange }) {
  useEffect(() => {
    tippy('[data-tippy-content]')
  }, [])

  return (
    <>
      {Data.map((elm, i) => (
        <React.Fragment key={`swatch-option2-${ProductID}-${i + 1}`}>
          <input
            type="radio"
            name={`option2-${ProductID}`}
            id={`swatch-option2-${ProductID}-${i + 1}`}
            value={elm}
            onChange={() => onChange && onChange(elm)}
          />
          <label
            className="swatch js-swatch"
            htmlFor={`swatch-option2-${ProductID}-${i + 1}`}
            aria-label={elm}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            data-tippy-content={elm}
          >
            {elm}
          </label>
        </React.Fragment>
      ))}
    </>
  )
}
